import { create } from "zustand";

// transient UI state shared across the topbar and the app shell (e.g. the My Links page)
export type ScoreView = "score" | "chord";   // "score" = 타브악보, "chord" = 코드악보

interface UiState {
  linksPage: boolean;
  setLinksPage: (v: boolean) => void;
  scoreView: ScoreView;
  setScoreView: (v: ScoreView) => void;
  // once a song is analyzed the input card collapses; "다른 곡" in the song header reopens it
  inputOpen: boolean;
  setInputOpen: (v: boolean) => void;
  // key · capo panel (popover on wide screens, bottom sheet on phones)
  keySheetOpen: boolean;
  setKeySheetOpen: (v: boolean) => void;
  // print option: chord diagrams above the chart
  printDiagrams: boolean;
  setPrintDiagrams: (v: boolean) => void;
}

export const useUi = create<UiState>((set) => ({
  linksPage: false,
  setLinksPage: (linksPage) => set({ linksPage }),
  scoreView: "chord",                          // default to the lead-sheet chord grid
  setScoreView: (scoreView) => set({ scoreView }),
  inputOpen: false,
  setInputOpen: (inputOpen) => set({ inputOpen }),
  keySheetOpen: false,
  setKeySheetOpen: (keySheetOpen) => set({ keySheetOpen }),
  printDiagrams: true,
  setPrintDiagrams: (printDiagrams) => set({ printDiagrams }),
}));
